import '../styles/App.css';
import '../styles/stakebody.css';
import React, {useState} from "react";
import {toast} from "react-toastify";
import {configVars} from "../config/config";

const StakeBody = params => {
    const [filter, setFilter] = useState("All");
    const [selectedStakedNFTs, setSelectedStakedNFTs] = useState([]);
    const [selectedUnstakedNFTs, setSelectedUnstakedNFTs] = useState([]);

    const collectionNameMapping = {
        "0x51112bf32b9a1c64716df2e6b82e63a04bd384fd": "Trooprz",
        "0xea4df145322ec9dfce037b062b08083141c6af8f": "SuperTrooprz",
        "0x96628048830a499b156abdc04cc169c18c3a17f2": "Mutantz",
        "0xeb54ea91c92ce404ba7ad7b0ef2e36fd75c889a7": "Boss Frogz",
        "0x2fff5fe8a3e13a10509e4297df9d1fdaf1ee7dc4": "Painted Pandaz",
        "0x8721b9ad32d1c7869f19d62ac4b764e3038cc1d2": "Bronze Bronze Vips",
        "0xa808030692001dd562f437fc676cd63eb232bc2a": "Empathy Silver Vips",
        "0x3ffcb84507c6d5a2b963d5f367feffa496e964c1": "Loyalty Gold Vips",
        "0xf8e63021c3d757b63eb53a9124271251a964d572": "Cronos Rocks",
        "0x75233b3c8b60b7191704c0f6100850dc769bb857": "Cronos Fox Fraternity",
        "0xe13a2bf710c4d1fd3a04a85e14489b4d352ca2f0": "NoBuddies OG",
        "0x1fe73d4cc73ea313056e41fe82e58d59d29c6592": "NoBuddies Gen2",
        "0xb72cddd1113b0906f5b82f507ad90c5cc65b22fb": "NoBuddies Gen3D",
        "0xf39363abc3434c600e731068fb8d25d4d8b2b668": "NoBu",
        "0xdccced571dcbc82bbeadf95af20ee4442e21208c": "Crougar",
        "0x45958cb5ede8dc9e1a797c1526d4523db1471f15": "CrougarX",
        "0x2a1ba5c6474949949e290e9a5e72fe9c631c9ab2": "THNDRKatz",
        "0x939b90c529f0e3a2c187e1b190ca966a95881fde": "Cronos Monkey Business",
        "0xf038c0cb2935fb8bf9b6e47bca1df0835f359f92": "Microchips Nfts",
        "0xaa6cb884573c97e0b26f771acc0c5c94f6ae8ffd": "Alpha Lions",
        "0x1767a7dddf0e888fa87efd46fdc7c43eda514f59": "Alpha Lady Lions",
        "0x7da8e3acda33ffa01396ff00e2c4b36ad899f8ad": "Apex Nfts",
        "0xbd6b9a1a0477d64e99f660b7b7c205f4604e4ff3": "Cronos Fossils",
        "0xeb850b8f7d00b4faf242888bef7efbf229eb1e41": "Looney Corns",
        "0x30ab0d8c808ec024365d45a105c559bdf06bcb14": "Cronos Fossils Gen2",
        "0x3cde8ea53ae063698334ddf7114b7051400be78b": "Cronos Foxes Evolution",
    };
    const selectFirstNFTsFromFilteredList = async (nfts, setSelectedNFTs, selectedNFTs, limit) => {
        // Filter the selected NFTs based on the current filter
        const filteredNFTs = nfts.filter((nft) => filterOptions[filter](nft));
        const firstNFTs = filteredNFTs.slice(0, limit);
        setSelectedNFTs(firstNFTs);
        return firstNFTs;
    };

    const selectFirstStaked25Checkboxes = async () => {
        return selectFirstNFTsFromFilteredList(params.stakedNFTs, setSelectedStakedNFTs, selectedStakedNFTs, 25);
    };

    const selectFirstUnstaked25Checkboxes = async () => {
        return selectFirstNFTsFromFilteredList(params.NFTObjects, setSelectedUnstakedNFTs, selectedUnstakedNFTs, 25);
    };

    const toggleNFTSelection = (nft) => {
        if (nft.owner === "0x10f7d0f375e375bc0caaf5e1d51555e14a000ff5") {
            if (selectedStakedNFTs.includes(nft)) {
                setSelectedStakedNFTs(selectedStakedNFTs.filter((item) => item !== nft));
            } else {
                setSelectedStakedNFTs([...selectedStakedNFTs, nft]);
            }
        } else {
            if (selectedUnstakedNFTs.includes(nft)) {
                setSelectedUnstakedNFTs(selectedUnstakedNFTs.filter((item) => item !== nft));
            } else {
                setSelectedUnstakedNFTs([...selectedUnstakedNFTs, nft]);
            }
        }
    };

    const generateFilterOptions = (nfts) => {
        const options = {
            All: (nft) => true,
            Staked: (nft) => nft.owner === "0x10f7d0f375e375bc0caaf5e1d51555e14a000ff5",
            Unstaked: (nft) => nft.owner !== "0x10f7d0f375e375bc0caaf5e1d51555e14a000ff5",
        };

        nfts.forEach((nft) => {
            const collectionName = collectionNameMapping[nft.tokenAddress];
            if (collectionName) {
                if (!options[collectionName]) {
                    options[collectionName] = (nftItem) => nftItem.tokenAddress === nft.tokenAddress;
                }
            }
        });
        return options;
    };

    const filterOptions = generateFilterOptions(params.allNFTs);

    const filteredNFTs = params.allNFTs
        .filter((nft) => filterOptions[filter](nft))
        .sort((a, b) => {

            const priorityMap = Object.fromEntries(
                configVars.troopzCollections.map((collection, index) => [collection, index])
            );

            const aPriority = priorityMap[a.name];
            const bPriority = priorityMap[b.name];

            if (aPriority !== undefined && bPriority === undefined) {
                return -1;
            } else if (aPriority === undefined && bPriority !== undefined) {
                return 1;
            } else if (aPriority !== undefined && bPriority !== undefined) {
                if (aPriority !== bPriority) {
                    return aPriority - bPriority;
                }
            }
            return a.tokenId - b.tokenId;
        });

    return (
        <div className="stakebody">
            <div className='stakebody__mainBox'>
                <div className='stakebody__buttonBar'>
                    <div className='stakebody__sorting'>
                        <div className='stakebody__sortBox'>
                            <p>Filter By</p>
                            <select onChange={e => {
                                setSelectedUnstakedNFTs([]);
                                setSelectedStakedNFTs([]);
                                setFilter(e.target.value);
                            }} name="Collection">
                                {Object.keys(filterOptions).map((option) => (
                                    <option key={option} value={option}>{option}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className='stakebody__batchStake'>
                        <table>
                            <tbody>
                            <tr>
                                <td align={"center"} className='stakebody__td'>
                                    <button
                                        title="Batch stake max of 25 selected NFTs"
                                        onClick={() => {
                                            if (selectedUnstakedNFTs.length >= 1) {
                                                params.selectedBatchStake(selectedUnstakedNFTs);
                                            } else {
                                                toast("Select at least one NFT to batch stake or use the Stake first 25 link below to stake the first 25 NFTs in your collection", {
                                                    className: 'custom-toast'
                                                });
                                            }
                                        }}
                                        className='stakebody__batchStakeButton'>Stake Selected NFTs<br/><span
                                        className='stakebody__buttonDesc'>(Max 25)</span></button>
                                </td>
                                <td align={"center"} className='stakebody__td'>
                                    <button
                                        title="Batch withdraw selected staked NFTs"
                                        onClick={() => {
                                            if (selectedStakedNFTs.length >= 1) {
                                                params.selectedBatchUnstake(selectedStakedNFTs);
                                            } else {
                                                toast("Select at least one NFT to batch unstake and make sure to keep an OG Troopr staked if not unstaking all", {
                                                    className: 'custom-toast'
                                                });
                                            }
                                        }}
                                        className='stakebody__batchStakeButton'>Unstake Selected NFTs<br/><span
                                        className='stakebody__buttonDesc'>(Max 25)</span></button>
                                </td>
                            </tr>
                            <tr>
                                <td align={"center"} className='stakebody__td'>
                                    {selectedUnstakedNFTs.length === 0 &&
                                        <button
                                            className="plain-link-button"
                                            onClick={async () => {
                                                if (selectedUnstakedNFTs.length > 1) {
                                                    toast("Use the Batch Stake button above to batch stake your selected NFTs", {
                                                        className: 'custom-toast'
                                                    })
                                                } else if (!params.NFTObjects || params.NFTObjects.length === 0) {
                                                    toast("You have no eligible unstaked NFTs in your collection", {
                                                        className: 'custom-toast'
                                                    })
                                                } else {
                                                    setSelectedStakedNFTs([]);
                                                    const selectedUnstakedNFTs = await selectFirstUnstaked25Checkboxes(params.NFTObjects);
                                                    setSelectedUnstakedNFTs(selectedUnstakedNFTs)
                                                }
                                            }}>Select first 25 unstaked NFTs
                                        </button>
                                    }
                                    {selectedUnstakedNFTs.length > 0 &&
                                        <button
                                            className="plain-link-button"
                                            onClick={async () => {
                                                setSelectedUnstakedNFTs([]);
                                            }
                                            }>Clear selection
                                        </button>}
                                </td>
                                <td align={"center"} className='stakebody__td'>
                                    {selectedStakedNFTs.length === 0 &&
                                        <button
                                            className="plain-link-button"
                                            onClick={async () => {
                                                if (selectedUnstakedNFTs.length >= 1) {
                                                    toast("Use the Batch Unstake button above to batch unstake your selected NFTs", {
                                                        className: 'custom-toast'
                                                    });

                                                } else if (params.stakeNFT < 1) {
                                                    toast("You have no NFTs staked", {
                                                        className: 'custom-toast'
                                                    })
                                                } else {
                                                    setSelectedUnstakedNFTs([]);
                                                    const selectedStakeNFTs = await selectFirstStaked25Checkboxes(params.stakedNFTs);
                                                    setSelectedStakedNFTs(selectedStakeNFTs)
                                                }
                                            }}>Select first 25 Staked NFTs
                                        </button>
                                    }
                                    {selectedStakedNFTs.length > 0 &&
                                        <button
                                            className="plain-link-button"
                                            onClick={async () => {
                                                setSelectedStakedNFTs([]);
                                            }
                                            }>Clear selection
                                        </button>}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='stakebody__boxes'>
                    {filteredNFTs.map((heldNFT, index) => {
                        const uniqueKey = `${heldNFT.tokenAddress}-${heldNFT.tokenId}`;
                        const isNFTSelected = selectedStakedNFTs.includes(heldNFT) || selectedUnstakedNFTs.includes(heldNFT);
                        return (
                            <React.Fragment key={uniqueKey}>
                                <div className='stakebody__box'>
                                    {heldNFT.tokenAddress === "0xea4df145322ec9dfce037b062b08083141c6af8f" &&
                                        <img className="stakebody__boxImg"
                                             src={`https://cdn.ltsglxy.network/ipfs/bafybeibkmr6w4eemeorrzcmlj2aju2uopdxjo5vh2v2gd2hglqvkoac7ve/${heldNFT.tokenId}.png`}
                                             alt=""></img>
                                    }
                                    {heldNFT.tokenAddress !== "0xea4df145322ec9dfce037b062b08083141c6af8f" &&
                                        <img className="stakebody__boxImg" src={`${heldNFT.tokenImage}`} alt=""></img>
                                    }
                                    <div className='stakebody__boxText'>
                                        <p className='stakebody__boxRank'>{heldNFT.name}</p>
                                        {heldNFT.rank &&
                                            <p className='stakebody__boxTitle'>ID: {heldNFT.tokenId} |
                                                Rank: {heldNFT.rank}</p>
                                        }
                                        {!heldNFT.rank &&
                                            <p className='stakebody__boxTitle'>ID: {heldNFT.tokenId}</p>
                                        }
                                        <p className='stakebody__boxReward'>Daily Yield: {heldNFT.dailyReward} TRPZ</p>
                                        {heldNFT.owner !== "0x10f7d0f375e375bc0caaf5e1d51555e14a000ff5" && (
                                            <div className='stakebody__boxButtons'>
                                                <button className='stakebody__boxButtonSingle' onClick={() => {
                                                    params.stakeNFT(heldNFT.tokenAddress.toLowerCase(), heldNFT.tokenId);
                                                }}>Stake
                                                </button>
                                            </div>
                                        )}
                                        {heldNFT.owner === "0x10f7d0f375e375bc0caaf5e1d51555e14a000ff5" && (
                                            <div className='stakebody__boxButtons'>
                                                <button className='stakebody__boxButtonSingleCounter' onClick={() => {
                                                    params.withdrawToken(heldNFT.tokenAddress, heldNFT.tokenId);
                                                }}>Unstake
                                                </button>
                                            </div>
                                        )}
                                        <div className='stakebody__boxCheck'>
                                            <input className='stakebody__checkBox' onClick={() => {
                                                toggleNFTSelection(heldNFT);
                                            }
                                            } type="checkbox" checked={isNFTSelected} onChange={(e) => {
                                                toggleNFTSelection(heldNFT);
                                            }}>
                                            </input>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default StakeBody;
